import { Icon } from '@material-ui/core';

import SmartPageIconImage from 'Console/assets/images/icons/SmartPageIcon.png';

interface SmartPageIconProps {
    className: string | undefined;
}

const SmartPageIcon = ({ className }: SmartPageIconProps): JSX.Element => (
    <Icon className={className}>
        <img height={16} src={SmartPageIconImage} />
    </Icon>
);

export default SmartPageIcon;
